import React, { useState, useEffect } from "react";
import { Form, Alert, Col, Row, Select, Checkbox, Button, Drawer } from "antd";
import DatePicker from "@general/datePicker";
import moment from "moment-jalaali";
import UserContract from "@general/userContract";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
const workingHours = [];
for (let i = 10; i <= 20; i++) {
  workingHours.push({ value: i + ":00", label: i + ":00" });
}

const GETHOLIDAYCONTRACT = gql`
  query ($holidayContractInput: HolidayContractInput!) {
    getHolidayContract(holidayContractInput: $holidayContractInput)
  }
`;
const REQUESTHOLIDAY = gql`
  mutation ($workAt: DateTime!, $startTime: String!, $endTime: String!) {
    createHolidayInvoice(
      workAt: $workAt
      startTime: $startTime
      endTime: $endTime
    ) {
      id
    }
  }
`;

function UserHoliday() {
  const [contractChekBox, SetContractChekbox] = useState(false);
  const [ensureChekBox, SetEnsureChekbox] = useState(false);
  const [userContractDrawer, setUserContractDrawer] = useState(false);
  const [workAt, setWorkAt] = useState(null);
  const [startTime, setStartTime] = useState("10:00");
  const [endTime, setEndTime] = useState("20:00");
  const [holidayContractInput, setHolidayContractInput] = useState({});
  const [holidayContract, setHolidayContract] = useState("");

  const navigate = useNavigate();
  const [runRequestHoliday, requestHoliday] = useMutation(REQUESTHOLIDAY, {
    onError(err) {
      console.log("error: ", err.message);
    },
    onCompleted(data) {
      navigate(`/invoice/${data.createHolidayInvoice.id}`);
    },
  });

  const [getContractData, contractData] = useLazyQuery(GETHOLIDAYCONTRACT, {
    fetchPolicy: "no-cache",
    onError(error) {
      console.log("dashboard error: " + error.message);
    },
    onCompleted({ getHolidayContract }) {
      setHolidayContract(getHolidayContract);
    },
  });
  useEffect(() => {
    setHolidayContractInput({
      workAt,
      startTime,
      endTime,
    });
  }, [workAt, startTime, endTime]);
  const getHolidayContract = () => {
    getContractData({
      variables: {
        holidayContractInput,
      },
    });
  };
  const openContractDrawer = () => {
    setUserContractDrawer(true);
    getHolidayContract();
  };
  const createInvoice = () => {
    const { workAt, startTime, endTime } = holidayContractInput;
    runRequestHoliday({
      variables: { workAt, startTime, endTime },
    });
  };

  
  return (
    <div>
      <Drawer
        title={"تعهدنامه استفاده از روز تعطیل"}
        placement="top"
        open={userContractDrawer}
        onClose={() => setUserContractDrawer(false)}
        height={300}
      >
        <UserContract
          contract={holidayContract}
          onCloseDrawer={() => setUserContractDrawer(false)}
        />
      </Drawer>
      <Row>
        <Col xs={24} md={16}>
          <Form
            layout="vertical"
            initialValues={{
              workAt: null,
              startTime: "10:00",
              endTime: "20:00",
            }}
          >
            <Alert
              message="از تعطیل بودن روز انتخاب شده اطمینان حاصل کنید"
              type="warning"
              style={{ marginBottom: "20px" }}
              showIcon
            />
            <Row gutter={20}>
              <Col xs={24} md={12}>
                <Form.Item
                  label="انتخاب روز"
                  name="workAt"
                  rules={[{ required: true, message: "این فیلد ضروری است" }]}
                >
                  <DatePicker
                    format="YYYY/MM/DD"
                    onChange={(date) => setWorkAt(date)}
                    className="rtl"
                    placeholder="انتخاب روز"
                    disabledDate={(current) => current < moment().endOf("day")}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} md={6}>
                <Form.Item
                  label="از ساعت"
                  name="startTime"
                  rules={[{ required: true, message: "این فیلد ضروری است" }]}
                >
                  <Select
                    onChange={(value) => setStartTime(value)}
                    style={{
                      width: 120,
                    }}
                    options={workingHours}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} md={6}>
                <Form.Item
                  label="تا ساعت"
                  name="endTime"
                  rules={[{ required: true, message: "این فیلد ضروری است" }]}
                >
                  <Select
                    onChange={(value) => setEndTime(value)}
                    style={{
                      width: 120,
                    }}
                    options={workingHours}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ marginTop: 60 }}>
              <Checkbox
                checked={contractChekBox}
                disabled={workAt && startTime && endTime ? false : true}
                onChange={() => SetContractChekbox(!contractChekBox)}
              >
                <Button
                  type="link"
                  style={{ fontWeight: "bold" }}
                  onClick={openContractDrawer}
                  disabled={workAt && startTime && endTime ? false : true}
                >
                  تعهدنامه
                </Button>
                مربوط به استفاده از خدمات صفاتک در روزهای تعطیل را مطالعه کرده و
                شرایط آن را قبول میکنم.
              </Checkbox>
            </Row>
            <Row>
              <Checkbox
                checked={ensureChekBox}
                onChange={() => SetEnsureChekbox(!ensureChekBox)}
              >
                از تعطیل بودن روز انتخاب شده در تقویم رسمی کشور مطمئن هستم.
              </Checkbox>
            </Row>
            <Row style={{ marginTop: 60 }}>
              <Button
                type="primary"
                disabled={!ensureChekBox || !contractChekBox}
                onClick={() => createInvoice()}
              >
                ادامه
              </Button>
            </Row>
          </Form>
        </Col>
        <Col xs={24} md={8}></Col>
      </Row>
    </div>
  );
}

export default UserHoliday;
